import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";

export default function ExtendAsProductNotFound() {
    

    return (
        <div className="extend-as-product-not-found-container">
           <div className="app-search-page">
                <div className="container">
                    <Row xl={2} sm={1} lg={2}>
                       <Col lg={8} xl={9}>
                            <div className="app-search-no-result">
                                <h1 className="app-search-header">Oops! That page can&apos;t be found.</h1>
                                <div className="app-search-body">
                                    <p className="app-header-subtitle">It looks like nothing was found at this location.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div>
            </div> 
        </div>
    )
}